export const parsePx = (value: string) => {
  const parsed = Number.parseFloat(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

let cachedSafeAreaBottomPx: number | null = null;

export const readSafeAreaBottomPx = () => {
  if (cachedSafeAreaBottomPx !== null) {
    return cachedSafeAreaBottomPx;
  }

  const rawSafeArea = getComputedStyle(
    document.documentElement,
  ).getPropertyValue("--app-safe-area-bottom");
  const parsedSafeArea = parsePx(rawSafeArea);

  if (parsedSafeArea || rawSafeArea.trim() === "0px") {
    cachedSafeAreaBottomPx = parsedSafeArea;
    return parsedSafeArea;
  }

  const probe = document.createElement("div");
  probe.style.position = "fixed";
  probe.style.visibility = "hidden";
  probe.style.pointerEvents = "none";
  probe.style.height = "0";
  probe.style.paddingBottom = "env(safe-area-inset-bottom, 0px)";
  document.body.appendChild(probe);
  const resolvedSafeArea = parsePx(getComputedStyle(probe).paddingBottom);
  probe.remove();

  cachedSafeAreaBottomPx = resolvedSafeArea;
  return resolvedSafeArea;
};

export const detectIOS = () => {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent;
  return (
    /iPad|iPhone|iPod/.test(ua) ||
    (ua.includes("Macintosh") && navigator.maxTouchPoints > 1)
  );
};
